
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/glacier-and-wave-2-teaser",
      function () {
        return require("private-next-pages/glacier-and-wave-2-teaser/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/glacier-and-wave-2-teaser"])
      });
    }
  